export default __webpack_public_path__ + "img/cSwbiBuA.4fae2334.svg";